import { useActiveProject } from "@/features/project/ActiveProject";
import { type HomeProjectAttachment } from "@repo/api";
import { ListView, ListViewItem } from "@repo/skapa";
import { t } from "@repo/translation";
import { hasItems } from "@repo/utils";

import { HomeProjectFileItem } from "../fileListItem/HomeProjectFileItem";
import { groupHomeProjectAttachments } from "../utils";
import { AttachmentAccordionItem, type FilesListBaseProps } from "./FilesList";

interface HomeProjectFilesListProps extends FilesListBaseProps {
  files?: HomeProjectAttachment[];
}

export const HomeProjectFilesList = ({
  files,
  editable,
  loading,
  loadingFileId,
  onDownload,
}: HomeProjectFilesListProps) => {
  const { opportunity } = useActiveProject();

  if (!hasItems(files)) {
    return null;
  }

  const groupedFiles = groupHomeProjectAttachments(files);

  return (
    <AttachmentAccordionItem
      id="home-project-attachments"
      title={`${t("label.home_project")} (${files?.length})`}
    >
      {Object.entries(groupedFiles).map(([homeProjectId, files]) => {
        const homeProjectTitle =
          opportunity?.customerProjects?.find(
            (project) => project.id === homeProjectId
          )?.name || homeProjectId;

        return (
          <ListView
            id={`home-project-${homeProjectId}-attachments`}
            key={`home-project-${homeProjectId}-attachments`}
          >
            {homeProjectTitle && <ListViewItem title={`${homeProjectTitle}`} />}
            {files?.map((file) => (
              <HomeProjectFileItem
                key={`home-project-attachment-${file.fileName}${file.updatedDate}`}
                file={file}
                editable={editable}
                loading={loading}
                loadingFileId={loadingFileId}
                onDownload={onDownload}
              />
            ))}
          </ListView>
        );
      })}
    </AttachmentAccordionItem>
  );
};
